<template>
  <div id="questions-default" class="flex flex-col gap-5">
    <div id="items">
      <div class="flex flex-row items-center gap-5">
        <p class="font-bold text-lg col-span-12 my-5">Itens</p>
        <p v-if="store.selectCorrect" class="text-sm text-red-500">
          {{
            t("labels.generic", {
              pt: "Você deve indicar qual o item correto",
              en: "You must indicate which item is correct",
            })
          }}
        </p>
      </div>
      <div
        id="item-question"
        class="grid grid-cols-12 gap-3"
        v-for="(item, i) in store.form.items"
        :key="i"
      >
        <div class="p-5 bg-white rounded-md shadow-sm border col-span-10 mb-5">
          <div id="enunciated-item" class="mb-5">
            <Textarea
              id="question-input"
              :autoResize="true"
              rows="3"
              cols="30"
              :placeholder="t('question.prompt.items.empty')"
              v-model="item.answerText"
              :class="
                store.v$.form.items.$each.$response.$errors[i].answerText
                  ?.length !== 0 && store.v$.form.$error
                  ? 'p-invalid'
                  : ''
              "
              :maxlength="999"
            />
            <Errors
              :errors="
                store.v$.form.items.$each.$response.$errors[i].answerText
              "
              :actualLength="item.answerText?.length"
              :maxLength="999"
            >
              <template #msg>
                {{ store.v$.form.$error ? t("validations.required") : "" }}
              </template>
            </Errors>
          </div>

          <div id="explanation-item" v-if="store.getIsAdaptive">
            <Textarea
              id="description-input"
              :autoResize="true"
              rows="5"
              cols="30"
              :placeholder="t('question.prompt.items.description.empty')"
              v-model="item.answerDescription"
              :class="
                store.v$.form.items.$each.$response.$errors[i].answerDescription
                  ?.length !== 0 && store.v$.form.$error
                  ? 'p-invalid'
                  : ''
              "
              :maxlength="999"
            />
            <Errors
              :errors="
                store.v$.form.items.$each.$response.$errors[i].answerDescription
              "
              :actualLength="item.answerDescription?.length"
              :maxLength="999"
            >
              <template #msg>
                {{ store.v$.form.$error ? t("validations.required") : "" }}
              </template>
            </Errors>
          </div>
        </div>

        <div
          id="item-action"
          class="col-span-2 flex flex-col justify-center items-center"
        >
          <v-icon
            name="hi-solid-check-circle"
            :class="`${
              item.id === store.form.correctItem?.id || item.correct
                ? 'text-green-500'
                : 'text-gray-400'
            } cursor-pointer hover:scale-95 transition-all ${
              store.v$.form.items.$each.$response.$errors[i].correct?.length !==
                0 && store.v$.form.$error
                ? 'border-2 border-red-500 rounded-full'
                : ''
            }`"
            :scale="item.id === store.form.correctItem?.id ? 4 : 3"
            @click="chooseCorrectItem(item, store.form.items)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useQuizQuestionsStore } from "@/store/quiz-questions";
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "DefaultQuestion",
  setup() {
    const { t } = useI18n();
    const store = useQuizQuestionsStore;

    function chooseCorrectItem(item, items): void {
      if (!items) return;

      items = items?.map((e) => {
        store.form.correctItem = null;
        e.correct = false;
        return e;
      });
      item.correct = true;
      store.setSelectCorrect(false);
    }

    onMounted(() => {});

    return { t, store, chooseCorrectItem };
  },
});
</script>
